module.exports = __webpack_public_path__ + "static/media/Maf_ATLAS.b400d60a.jpg";